import React from 'react';

function SearchTitle({ rideStations, date, forwardRef }) {
  return (
    <div className="flex gap-3 w-full flex-col lg:flex-row font-big-bold" ref={forwardRef}>
      <div className="flex gap-3">
        <h1 className="m-0 text-2xl">{rideStations}</h1>
        <p className="items-center m-0 lg:flex hidden"><i className="arrow right" /></p>
      </div>
      <h1 className="m-0 text-2xl">{date}</h1>
    </div>
  );
}

export default SearchTitle;
